
import { useEffect } from 'react';
import { checkForStaleCache, addDevRefreshButton } from '@/utils/devCacheUtil';
import { isProduction } from '@/utils/environment';

/**
 * AppCacheManager component that helps manage application cache
 * and provides development tools for cache clearing
 * 
 * For detailed environment detection rules, see docs/DEBUG.md
 */
export function AppCacheManager() {
  useEffect(() => {
    // Only in non-production environment (based on URL patterns - see docs/DEBUG.md)
    if (!isProduction()) {
      console.log('AppCacheManager: Initializing development cache management');
      console.log('AppCacheManager: Environment check - NODE_ENV:', process.env.NODE_ENV);
      console.log('AppCacheManager: Environment check - URL:', window.location.href);
      console.log('AppCacheManager: Environment check - Hostname:', window.location.hostname);
      
      // Check for stale cache on load
      const isStale = checkForStaleCache();
      if (isStale) {
        console.warn('AppCacheManager: Cache appears to be stale. UI changes may not be visible.');
      }
      
      // Add the dev refresh button for convenience
      addDevRefreshButton();
      
      // Update the last build time
      sessionStorage.setItem('last-build-time', Date.now().toString());
      
      // Monitor for HMR updates if available
      if (import.meta.hot) {
        import.meta.hot.on('vite:beforeUpdate', () => {
          console.log('HMR update detected, preparing for refresh...');
          
          // Store current route to restore after refresh if needed
          try {
            const currentPath = window.location.pathname;
            sessionStorage.setItem('hmr-current-route', currentPath);
          } catch (e) {
            // Ignore storage errors
          }
        });
      }
    } else {
      console.log('AppCacheManager: Production environment detected, skipping development cache tools');
    }
    
    return () => {
      // Clean up the refresh button if component unmounts
      const devButton = document.getElementById('dev-refresh-button');
      if (devButton) {
        devButton.remove();
      }
    };
  }, []);

  // This component doesn't render anything
  return null;
}

export default AppCacheManager;
